import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { ReactComponent as SearchIcon } from "../assets/btn-send.svg";
import { useRecoEngine } from "../context/RecoEngineContext";
import { useRecoEngineActions } from "../hooks";

interface ChatBarProps {
  disabled: boolean;
}

const ChatBar = ({ disabled }: ChatBarProps) => {
  const {
    queryObject,
    setQueryObject,
  } = useRecoEngine();
  const [t] = useTranslation("translations");
  const [inputValue, setInputValue] = useState("");
  const { executeAction } = useRecoEngineActions();
  
  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInputValue(e.target.value);
  };

  const handleSend = async () => {
    if (!inputValue.trim()) return;

    executeAction("send_message", {
      userMessage: inputValue,
      analyticsEvent: "Submit New Query",
      sessionData: [
        {
          type: "chat",
          data: {
            text: inputValue,
          },
        },
      ],
    });

    setQueryObject({
      ...queryObject,
      query: inputValue,
    });
    setInputValue("")
  };

  return (
    <div className={`recoEngine__chatBar ${disabled ? "chatBar__disabled" : ""}`}>
      <form onSubmit={(e) => { e.preventDefault(); handleSend() }}>
      <div className="input-wrapper">
        <textarea
          disabled={disabled}
          placeholder={t("RecoSearch.placeholder_ask")}
          onChange={handleInputChange}
          maxLength={300}
          value={inputValue}
          aria-label="Search"
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleSend();
            }
          }}
        />
        <button 
          type="submit"
          disabled={!inputValue.trim()}
          aria-label={`Send message: ${inputValue}`}
        >
          <SearchIcon />
        </button>
      </div>
      </form>
    </div>
  );
};

export default ChatBar;
